import React, { useState } from 'react'
import TypeaheadInput from 'components/TypeaheadInput'
import './style.scss'

const VisitVolunteer = props => {
  const [state, setState] = useState(() => {
    return {
      ...props,
      errors: null
    }
  })

  const onChange = () => {
    setState(() => ({ ...props, errors: null }))
  }

  return (
    <>
      <div className={`input required ${state.errors ? 'error' : null} `} id='visit_linkage_attributes_companion_id_input'>
        <label className={`label mb-3`}>
          Volunteer <abbr title='required'>*</abbr>
        </label>
        <br />
        <div className='org-typeahead'>
          <TypeaheadInput {...state} onChange={onChange} />
        </div>
      </div>
    </>
  )
}

export default VisitVolunteer
